﻿/**
 * portal-app-logo.directive
 * @namespace portal
 */

(function () {
	'use strict';

	/** get the angular module and add directive */
	angular.module('nha.portal').directive('portalAppLogo', portalAppLogoDirective);

	/** injection */
	portalAppLogoDirective.$inject = ['appSettings'];

	/** implementation */
	function portalAppLogoDirective(appSettings) {
		/** return directive */
		return {
			restrict: 'E',
			replace: true,
			templateUrl: appSettings.portalWebRootUrl + 'app/directives/portal-app-logo/portal-app-logo.directive.html',
			controller: 'portal-app-logo.controller',
			controllerAs: 'portalAppLogoCtrl',
			bindToController: {
				settingKey: '=',
				isTraining: '=?'
			},
			scope: {}
		};
	}
})();